import { getSupabaseBrowserClient } from "@/lib/supabase/client";
import { apiError } from "./errors";
import { ProfileSchema } from "./schemas";
import type { Profile } from "@/lib/supabase/types";

const sb = () => getSupabaseBrowserClient();

export async function getProfile(userId: string): Promise<Profile> {
  const { data, error } = await sb()
    .from("profiles")
    .select("*")
    .eq("id", userId)
    .single();

  if (error) throw apiError(error);
  return ProfileSchema.parse(data);
}

